import { calendarResourceTypes } from '../calendarResourceTypes';
import { type CalendarExperteEvent } from './CalendarExperteEvent';
import { type CalendarRaumEvent } from './CalendarRaumEvent';
import { type CalendarStandortEvent } from './CalendarStandortEvent';

export type CalendarEvent = CalendarExperteEvent | CalendarRaumEvent | CalendarStandortEvent;
export const isExperteEvent = (event: Pick<CalendarEvent, 'type'>): event is CalendarExperteEvent =>
  event.type === calendarResourceTypes.EXPERTE;
export const isSeminarraumEvent = (event: Pick<CalendarEvent, 'type'>): event is CalendarRaumEvent =>
  event.type === calendarResourceTypes.SEMINARRAUM;
export const isGruppenraumEvent = (event: Pick<CalendarEvent, 'type'>): event is CalendarRaumEvent =>
  event.type === calendarResourceTypes.GRUPPENRAUM;
export const isStandortEvent = (event: Pick<CalendarEvent, 'type'>): event is CalendarStandortEvent =>
  event.type === calendarResourceTypes.STANDORT;

export type InternalCalendarEvent = CalendarEvent & {
  blockungData: CalendarEvent['blockungData'] & {
    veranstaltung: NonNullable<CalendarEvent['blockungData']['veranstaltung']>;
  };
};
